import React from "react";
import Page from "../Page/Page";
import styles from "./pageNotFound.module.scss";
const PageNotFound = ({ title = "Page not found!", byline, children, }) => (React.createElement(Page.Root, null,
    React.createElement(Page.Body, { className: styles.body },
        React.createElement("article", { className: styles.article },
            React.createElement("h1", null, title),
            byline && React.createElement("p", null, byline),
            children && React.createElement("p", null, children)))));
export default PageNotFound;
//# sourceMappingURL=PageNotFound.js.map